// Centralized configuration for search spaces
// This file manages which search spaces have access to specific features

export const SEARCH_SPACE_CONFIG = {
  // Search spaces that should display the remediation data table
  remediationEnabledSpaces: [
    'in'
  ],
};

// Helper function to check if a search space has remediation access
export const hasRemediationAccess = (searchSpace) => {
  return SEARCH_SPACE_CONFIG.remediationEnabledSpaces.includes(searchSpace);
};

// Helper function to get all remediation-enabled spaces
export const getRemediationEnabledSpaces = () => {
  return SEARCH_SPACE_CONFIG.remediationEnabledSpaces;
};

// Helper function to add a new remediation-enabled space
export const addRemediationSpace = (spaceName) => {
  if (!SEARCH_SPACE_CONFIG.remediationEnabledSpaces.includes(spaceName)) {
    SEARCH_SPACE_CONFIG.remediationEnabledSpaces.push(spaceName);
  }
};

// Helper function to remove a remediation-enabled space
export const removeRemediationSpace = (spaceName) => {
  const index = SEARCH_SPACE_CONFIG.remediationEnabledSpaces.indexOf(spaceName);
  if (index > -1) {
    SEARCH_SPACE_CONFIG.remediationEnabledSpaces.splice(index, 1);
  }
};

